import React, {useState} from 'react';
import useFetchData from 'js/hooks/useFetchData/useFetchData';
import DataValidator from 'js/components/Common/DataValidator/DataValidator';

import fetchData from './fetchData';
import classes from './PlaytechServices.module.pcss';
import Container from 'js/components/Common/Container/Container';
import parse from 'html-react-parser';

interface Props {
    pageId: number
}

const PlaytechServices = ({pageId}: Props) => {
    const [title, setTitle] = useState<string>('');
    const [description, setDescription] = useState<string>('');

    const {isLoading, error} = useFetchData({
        query: `${fetchData(pageId)}`,
        condition: !!pageId,
        updateData: (data: any): void => {
			const result = data?.page?.ServicesTemplate;
			setTitle(result?.titleServices);
			setDescription(result?.descriptionServices);
        }
    });

    return (
        <DataValidator data={!isLoading && !error && title?.length > 0 && description?.length > 0}>
            <section className={classes.PlaytechServices}>
				<Container additionalClass={classes.Wrap}>
					{parse(title || '')}
					{parse(description || '')}
				</Container>
            </section>
        </DataValidator>
    );
};

export default PlaytechServices;
